import {Injectable, signal, WritableSignal} from '@angular/core';
import {DatabaseService} from './database.service';
import {PrinterConfig, PrinterMapping} from '../../graphql/generated';

@Injectable({
  providedIn: 'root',
})
export class PrinterConfigService {
  sectionPrinters: WritableSignal<{ [key: string]: PrinterConfig }> = signal({});
  sectionLessPrinters: WritableSignal<{ [key: string]: PrinterConfig }> = signal({});

  constructor(private databaseService: DatabaseService) {}

  async handlePrinterConfig() {
    const printerConfigs = await this.databaseService.getPrinterConfigs();

    printerConfigs.forEach((printerConfig) => {
      if (printerConfig.section_id) {
        this.sectionPrinters.update((sectionPrinters) => {
          sectionPrinters[printerConfig.section_id] = printerConfig;
          return sectionPrinters;
        });
      } else {
        this.sectionLessPrinters.update((sectionLessPrinters) => {
          sectionLessPrinters[printerConfig.branch_id] = printerConfig;
          return sectionLessPrinters;
        });
      }
    });
  }

  async getBranchPrinterMapping(branchId: string): Promise<PrinterMapping | null> {
    const printerConfig = await this.databaseService.getBranchPrinterConfig(branchId);
    return printerConfig ? this.getFirstPrinterMapping(printerConfig) : null;
  }

  async getSectionBillPrinterMapping(sectionId: string): Promise<PrinterMapping | null> {
    const printerConfig = await this.databaseService.getSectionPrinterConfig(sectionId);
    return this.getBillPrinterMapping(printerConfig);
  }

  private getFirstPrinterMapping(printerConfig: PrinterConfig): PrinterMapping | null {
    const printerMappings = printerConfig?.printer_mappings || [];
    return printerMappings.length ? printerMappings[0] : null;
  }

  private getBillPrinterMapping(printerConfig: PrinterConfig): PrinterMapping | null {
    const printerMappings = printerConfig?.printer_mappings || [];

    for (const printerMapping of printerMappings) {
      if (printerMapping.is_bill_printer) {
        return printerMapping;
      }
    }

    return null;
  }
}
